export const APP_NAME = 'ThanksChat';
export const API_ROOT = process.env.REACT_APP_API_ROOT || 'https://thanks.au.ngrok.io';
export const WEBSITE_ROOT = process.env.REACT_APP_WEBSITE_ROOT || 'https://thanks-frontend.au.ngrok.io'
export const SLACK_CLIENT_ID = process.env.REACT_APP_SLACK_CLIENT_ID || '406442321492.1141280923233'
export const GA_ID = process.env.REACT_APP_GA_ID || ''